// extracted by mini-css-extract-plugin
export default {"container":"Xg7BrWgy0l3TdxBxHBJ3","divider":"BVzJ2MRl5Ou6LlqeVApg","pagination":"jVnGlGtfx7uyfaJSn1rF","searchInput":"daVjCLwMv8prDymtmsU4"};